import React from 'react'
import {ListProps} from '.'

export const List: React.FC<ListProps> = ({children}) => <ul>{children}</ul>
